/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  GetApiV1PtaxQuotations200,
  GetApiV1PtaxQuotationsAllDate200,
  GetApiV1PtaxQuotationsCurrencyCode200,
  GetApiV1PtaxQuotationsCurrencyCodeDate200,
  GetApiV1PtaxQuotationsHighestAboveCap200,
  GetApiV1PtaxQuotationsHighestAboveCapParams,
  GetApiV1PtaxQuotationsHighestTwelveMonth200,
  GetApiV1PtaxQuotationsHighestTwelveMonthAboveCap200,
  GetApiV1PtaxQuotationsHighestTwelveMonthAboveCapParams,
  GetApiV1PtaxQuotationsHighestTwelveMonthParams,
  GetApiV1PtaxQuotationsHistoryCurrencyCode200,
  GetApiV1PtaxQuotationsHistoryCurrencyCodeParams,
  GetApiV1PtaxQuotationsLastImport200,
  GetApiV1PtaxQuotationsParams,
  GetApiV1PtaxQuotationsPreviousDayPtax200,
  GetApiV1PtaxQuotationsPreviousDayPtaxLessHoliday200,
  GetApiV1PtaxQuotationsPreviousDayPtaxLessHolidayParams,
  GetApiV1PtaxQuotationsPreviousDayPtaxParams,
  GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode200,
  GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCodeParams
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPtax = () => {
/**
 * @summary Obtém as cotações mais recentes para todas as moedas com os filtros fornecidos.
 */
const getPtaxQuotations = (
    params?: GetApiV1PtaxQuotationsParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotations200>>,) => {
      return customInstance<GetApiV1PtaxQuotations200>(
      {url: `/api/v1/ptax-quotations`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obtém a cotação mais recente para uma moeda específica fornecida por código de moeda.
 */
const getPtaxQuotationsCurrencyCode = (
    currencyCode: string,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsCurrencyCode200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsCurrencyCode200>(
      {url: `/api/v1/ptax-quotations/${currencyCode}`, method: 'GET'
    },
      options);
    }
  const getPtaxQuotationsCurrencyCodeDate = (
    currencyCode: string,
    date: string,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsCurrencyCodeDate200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsCurrencyCodeDate200>(
      {url: `/api/v1/ptax-quotations/${currencyCode}/${date}`, method: 'GET'
    },
      options);
    }
  const getPtaxQuotationsAllDate = (
    date: string,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsAllDate200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsAllDate200>(
      {url: `/api/v1/ptax-quotations/all/${date}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém o histórico das cotações para uma moeda específica fornecida por código de moeda.
 */
const getPtaxQuotationsHistoryCurrencyCode = (
    currencyCode: string,
    params?: GetApiV1PtaxQuotationsHistoryCurrencyCodeParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsHistoryCurrencyCode200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsHistoryCurrencyCode200>(
      {url: `/api/v1/ptax-quotations/history/${currencyCode}`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obtém a data e hora da última importação bem-sucedida de cotações.
 */
const getPtaxQuotationsLastImport = (

 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsLastImport200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsLastImport200>(
      {url: `/api/v1/ptax-quotations/last-import`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Recupera a maior cotação PTAX para uma moeda específica nos últimos doze meses.
 */
const getPtaxQuotationsHighestTwelveMonth = (
    params?: GetApiV1PtaxQuotationsHighestTwelveMonthParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsHighestTwelveMonth200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsHighestTwelveMonth200>(
      {url: `/api/v1/ptax-quotations/highest-twelve-month`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Recupera a cotação PTAX do dia D-1 anterior para uma moeda específica.
 */
const getPtaxQuotationsPreviousDayPtax = (
    params?: GetApiV1PtaxQuotationsPreviousDayPtaxParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsPreviousDayPtax200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsPreviousDayPtax200>(
      {url: `/api/v1/ptax-quotations/previous-day-ptax`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Recupera a maior cotação PTAX para uma moeda específica nos últimos doze meses passando o cap.
 */
const getPtaxQuotationsHighestTwelveMonthAboveCap = (
    params?: GetApiV1PtaxQuotationsHighestTwelveMonthAboveCapParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsHighestTwelveMonthAboveCap200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsHighestTwelveMonthAboveCap200>(
      {url: `/api/v1/ptax-quotations/highest-twelve-month-above-cap`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Recupera a maior cotação PTAX para uma moeda específica passando o cap.
 */
const getPtaxQuotationsHighestAboveCap = (
    params?: GetApiV1PtaxQuotationsHighestAboveCapParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsHighestAboveCap200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsHighestAboveCap200>(
      {url: `/api/v1/ptax-quotations/highest-above-cap`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Recupera a cotação PTAX do dia D-1 anterior, porém se for feriado, pegar o a ptax antes do feriado
 */
const getPtaxQuotationsPreviousDayPtaxLessHoliday = (
    params?: GetApiV1PtaxQuotationsPreviousDayPtaxLessHolidayParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsPreviousDayPtaxLessHoliday200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsPreviousDayPtaxLessHoliday200>(
      {url: `/api/v1/ptax-quotations/previous-day-ptax-less-holiday`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Recupera a cotação PTAX de N dias anteriores (D-2, D-3, D-4, etc.), considerando feriados e usando código da moeda.
 */
const getPtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode = (
    currencyCode: string,
    params?: GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCodeParams,
 options?: SecondParameter<typeof customInstance<GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode200>>,) => {
      return customInstance<GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode200>(
      {url: `/api/v1/ptax-quotations/previous-days-ptax-less-holiday/${currencyCode}`, method: 'GET',
        params
    },
      options);
    }
  return {getPtaxQuotations,getPtaxQuotationsCurrencyCode,getPtaxQuotationsCurrencyCodeDate,getPtaxQuotationsAllDate,getPtaxQuotationsHistoryCurrencyCode,getPtaxQuotationsLastImport,getPtaxQuotationsHighestTwelveMonth,getPtaxQuotationsPreviousDayPtax,getPtaxQuotationsHighestTwelveMonthAboveCap,getPtaxQuotationsHighestAboveCap,getPtaxQuotationsPreviousDayPtaxLessHoliday,getPtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode}};
export type GetApiV1PtaxQuotationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotations']>>>
export type GetApiV1PtaxQuotationsCurrencyCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsCurrencyCode']>>>
export type GetApiV1PtaxQuotationsCurrencyCodeDateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsCurrencyCodeDate']>>>
export type GetApiV1PtaxQuotationsAllDateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsAllDate']>>>
export type GetApiV1PtaxQuotationsHistoryCurrencyCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsHistoryCurrencyCode']>>>
export type GetApiV1PtaxQuotationsLastImportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsLastImport']>>>
export type GetApiV1PtaxQuotationsHighestTwelveMonthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsHighestTwelveMonth']>>>
export type GetApiV1PtaxQuotationsPreviousDayPtaxResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsPreviousDayPtax']>>>
export type GetApiV1PtaxQuotationsHighestTwelveMonthAboveCapResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsHighestTwelveMonthAboveCap']>>>
export type GetApiV1PtaxQuotationsHighestAboveCapResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsHighestAboveCap']>>>
export type GetApiV1PtaxQuotationsPreviousDayPtaxLessHolidayResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsPreviousDayPtaxLessHoliday']>>>
export type GetApiV1PtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCodeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPtax>['getPtaxQuotationsPreviousDaysPtaxLessHolidayCurrencyCode']>>>
